import { Award, Lock } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const MIN_SLOTS = 4;

/**
 * SidebarAchievements — "Rozetler" card: earned badges (colored medal) +
 * remaining locked slots (padlock), with an earned-count header.
 *
 * Props:
 *   achievements — array of earned badge/achievement objects (may be empty
 *                  while no badge endpoint is wired to this page — see Dashboard.js)
 */
export default function SidebarAchievements({ achievements = [] }) {
  const { t } = useLanguage();

  const earnedCount = achievements.length;
  const lockedSlots = Math.max(0, MIN_SLOTS - earnedCount);

  return (
    <div className="card-duo p-[18px]" data-testid="sidebar-achievements">
      <div className="flex items-center justify-between mb-2.5">
        <h3 className="font-duo-display text-[15px] text-[#0E1F3D]">
          {t('dashboard.duo.achievements')}
        </h3>
        <span className="text-xs font-bold text-[#16794a]">
          {t('dashboard.duo.badgesEarnedCount').replace('{{count}}', earnedCount)}
        </span>
      </div>

      <div className="flex items-center gap-2.5 flex-wrap">
        {achievements.slice(0, MIN_SLOTS).map((a, idx) => (
          <div
            key={a.id || a._id || idx}
            className="w-11 h-11 rounded-xl bg-[#eaf8ef] flex items-center justify-center"
            title={a.name || a.title || ''}
          >
            <Award size={22} strokeWidth={2} className="text-[#16794a]" aria-hidden="true" />
          </div>
        ))}
        {Array.from({ length: lockedSlots }).map((_, idx) => (
          <div
            key={`locked-${idx}`}
            className="w-11 h-11 rounded-xl bg-[#f2f5f3] flex items-center justify-center opacity-40"
            aria-hidden="true"
          >
            <Lock size={20} strokeWidth={2} className="text-[#8a978d]" />
          </div>
        ))}
      </div>
    </div>
  );
}
